export default __webpack_public_path__ + "static/media/push47.04f93ea5.gif";